export default __webpack_public_path__ + "static/media/1573.a1f9a448.png";